import { terrainRasterTileConfig } from "./display-layers/terrainRasterTiles";

export const rasterTileRegistry = {
  ...terrainRasterTileConfig,
};